"use client"

import { createIcon } from "@chakra-ui/react"

export const EmailOutlineIcon = createIcon({
  displayName: "EmailOutlineIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "currentColor",
  },
  path: (
    <>
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z" />
    </>
  ),
})

export const MailIcon = createIcon({
  displayName: "MailIcon",
  viewBox: "0 0 512 512",
  defaultProps: {
    fill: "currentColor",
  },
  path: (
    <>
      <path d="M424 80H88a56.06 56.06 0 0 0-56 56v240a56.06 56.06 0 0 0 56 56h336a56.06 56.06 0 0 0 56-56V136a56.06 56.06 0 0 0-56-56zm-14.18 92.63-144 112a16 16 0 0 1-19.64 0l-144-112a16 16 0 1 1 19.64-25.26L256 251.73l134.18-104.36a16 16 0 0 1 19.64 25.26z" />
    </>
  ),
})

export const MailLuIcon = createIcon({
  displayName: "MailLuIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  },
  path: (
    <>
      <rect width="20" height="16" x="2" y="4" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </>
  ),
})

export const MailOutline2Icon = createIcon({
  displayName: "MailOutline2Icon",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "currentColor",
  },
  path: (
    <>
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" />
    </>
  ),
})

export const MailOutlineIcon = createIcon({
  displayName: "MailOutlineIcon",
  viewBox: "0 0 512 512",
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
  },
  path: (
    <>
      <rect
        width="416"
        height="320"
        x="48"
        y="96"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        rx="40"
        ry="40"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="m112 160 144 112 144-112"
      />
    </>
  ),
})

export const MessageReplyIcon = createIcon({
  displayName: "MessageReplyIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  },
  path: (
    <>
      <path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z" />
      <path d="M11 8l-3 3l3 3" />
      <path d="M16 11h-8" />
    </>
  ),
})

export const MessageSquareReplyIcon = createIcon({
  displayName: "MessageSquareReplyIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  },
  path: (
    <>
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      <path d="m10 7-3 3 3 3" />
      <path d="M17 13v-1a2 2 0 0 0-2-2H7" />
    </>
  ),
})
